import * as React from "react";
import type { SVGProps } from "react";
const SvgList2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    viewBox="0 0 14 14" {...props}
  >
    <path
      fill="#2D3949"
      fillRule="evenodd"
      d="M2.667 2.123C2.667 1.503 3.152 1 3.75 1h6.5c.599 0 1.084.503 1.084 1.123v8.982c0 .21-.114.403-.294.5a.53.53 0 0 1-.563-.043l-1.58-1.17-1.582 1.17a.53.53 0 0 1-.63 0l-1.58-1.17-1.582 1.17a.53.53 0 0 1-.562.042.56.56 0 0 1-.294-.499zm2.167 1.403c0-.31.242-.561.541-.561h3.25c.3 0 .542.251.542.561s-.243.562-.542.562h-3.25a.55.55 0 0 1-.541-.562m.541 1.685c-.299 0-.541.25-.541.56s.242.562.541.562h3.25c.3 0 .542-.251.542-.561a.55.55 0 0 0-.542-.561zm0 2.245c-.299 0-.541.251-.541.562 0 .31.242.561.541.561h3.25c.3 0 .542-.251.542-.561a.55.55 0 0 0-.542-.562z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgList2;
